export default __webpack_public_path__ + "static/media/1401.1b50917a.png";